import React from 'react';
import { EmptyState } from '@/components/common/residents/EmptyState';
import { linkedAccountsStrings } from '@/constants/residents/strings';

export const LinkedAccountsEmpty: React.FC = () => (
  <EmptyState
    title={linkedAccountsStrings.empty.title}
    description={linkedAccountsStrings.empty.description}
    iconName="people-outline"
  />
);


